"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ClipBoard = function ClipBoard() {
  return _react2.default.createElement(
    "g",
    { id: "clip-board" },
    _react2.default.createElement("path", {
      d: "M429.715127,49.9948274 L321.893478,49.9948274 C310.329482,19.87793 281.404042,0 249.14333,0 C216.882618,0 187.957179,19.87793 176.393182,49.9948274 L68.607248,49.9948274 C40.5829913,49.6363302 17.5279922,71.9733535 17,99.9949293 L17,449.995643 C17.5279922,478.017218 40.5829913,500.354242 68.607248,499.995744 L429.715127,499.995744 C457.725529,500.334436 480.75869,478.003116 481.28666,449.995643 L481.28666,99.9949293 C480.75869,71.9874556 457.725529,49.6561362 429.715127,49.9948274 L429.715127,49.9948274 Z M249.14333,49.9948274 C262.839916,50.425506 273.637148,61.801879 273.352259,75.502273 C273.06737,89.202667 261.80655,100.12036 248.1039,99.9812918 C234.40125,99.842224 223.364333,88.6982324 223.357563,74.9948784 C223.611864,60.986936 235.134225,49.8156719 249.14333,49.9948274 Z M300.750578,399.995541 L120.178782,399.995541 L120.178782,349.995439 L300.750578,349.995439 L300.750578,399.995541 Z M378.107879,299.995337 L120.178782,299.995337 L120.178782,249.995235 L378.107879,249.995235 L378.107879,299.995337 Z M378.107879,199.995133 L120.178782,199.995133 L120.178782,149.995031 L378.107879,149.995031 L378.107879,199.995133 Z",
      id: "Shape"
    })
  );
};

exports.default = ClipBoard;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-icon/Icons/ClipBoard.js
// module id = 2935
// module chunks = 4